import React from "react";
import styled from "styled-components";

type GraphLegendProps = {
    data:{
        value:number,
        color:string,
        legendText?:string,
    }[],
    showValueDecimals?:boolean
}
export function GraphLegend(props:GraphLegendProps):JSX.Element
{
    const validSegments = props.data.filter(segment => segment.value >= 0);
    const valueTotal = validSegments.reduce((acc, segment) => acc + segment.value, 0);
    

    return (
        <div style={{display:'flex', justifyContent:'flex-start', gap:'20px', rowGap:'4px', flexWrap:'wrap'}}>
            
            {validSegments.map((segment, index) => 
                <div key={index} style={{display:'flex', alignItems:'center', gap:'5px'}}>
                    <div style={{width:'12px', height:'12px', backgroundColor:segment.color}}></div>
                    <span style={{fontSize:11}}>
                        {segment.legendText || graphLegendDefaultText(segment.value, valueTotal, props.showValueDecimals)}
                    </span>
                </div>
            )}

        </div>
    );
}

export const graphLegendDefaultText = (val:number, valueTotal:number, showDecimals?:boolean) => ` ${(val/valueTotal*100).toFixed(showDecimals ? 1 : 0)}% (${val})`; 

export const GraphLegendText = styled.span`
    font-size: 12px;
    color: #666;
`;